import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Cirf } from "../cirf";
import { CirfClientInfo } from "../cirf-client-info";
import { Utils } from "../../common/utils";
import { CirfService } from "../cirf.service";

export class ClientNameLookupDialogParams {
  cirfClient: CirfClientInfo;
  cirf: Cirf;
}

@Component({
  selector: "client-name-lookup-dialog",
  templateUrl: "./client-name-lookup-dialog.component.html",
})
export class ClientNameLookupDialogComponent implements OnInit {
  showValidationError: boolean = false;
  matchFound: boolean = true;
  cirfClientNew: CirfClientInfo;
  cirfClientFound: CirfClientInfo;
  sourceCirfGuid: string;
  sourceSourceId: string;
  lastUpdateTimeStamp: number;

  constructor(
    public dialogRef: MatDialogRef<ClientNameLookupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public params: ClientNameLookupDialogParams,
    public cirfService: CirfService
  ) {}

  ngOnInit() {
    this.cirfClientNew = new CirfClientInfo();
    this.cirfClientNew.id = Utils.uuid();
    this.cirfClientNew.gender = "QUESTION";
    if (this.params && this.params.cirfClient) {
      this.cirfClientNew.firstName =
        this.params.cirfClient && this.params.cirfClient.firstName
          ? this.params.cirfClient.firstName
          : "";
      this.cirfClientNew.lastName =
        this.params.cirfClient && this.params.cirfClient.lastName
          ? this.params.cirfClient.lastName
          : "";
      if (this.params.cirf) {
        this.updateDataWithCirf(this.params.cirf);
      }
    }
  }

  updateDataWithCirf(cirf: Cirf) {
    if (cirf && cirf.cirfClients && cirf.cirfClients.length > 0) {
      let cirfClient = cirf.cirfClients.find(
        (client) =>
          client.firstName &&
          client.firstName.toLowerCase() ==
            this.cirfClientNew.firstName.toLowerCase() &&
          client.lastName &&
          client.lastName.toLowerCase() ==
            this.cirfClientNew.lastName.toLowerCase()
      );
      if (cirfClient) {
        this.sourceCirfGuid = cirf.cirfGuid;
        this.sourceSourceId = cirfClient.id;
        this.lastUpdateTimeStamp = cirf.lastUpdatedTimeStamp;
        this.matchFound = false;
        this.cirfClientFound = new CirfClientInfo(cirfClient);
        this.cirfClientFound.clearAllIds();
        this.cirfClientFound.id = Utils.uuid();
      } else {
        this.onCancel();
      }
      // this.searchLoading = false;
    } else {
      this.onCancel();
    }
  }

  search(): void {
    this.matchFound = false;
    this.showValidationError =
      !this.cirfClientNew.firstName ||
      this.cirfClientNew.firstName.trim() == "" ||
      !this.cirfClientNew.lastName ||
      this.cirfClientNew.lastName.trim() == "";
    if (!this.showValidationError) {
      this.cirfService
        .getLookupCirfClient(
          this.cirfClientNew.firstName,
          this.cirfClientNew.lastName
        )
        .subscribe(
          (cirf: Cirf) => {
            this.updateDataWithCirf(cirf);
          },
          (error) => {
            this.onCancel();
          }
        );
    } else {
      this.onCancel();
    }
  }

  ok(): void {
    this.dialogRef.close({
      cirfClient: this.cirfClientFound,
      sourceCirfGuid: this.sourceCirfGuid,
      sourceSourceId: this.sourceSourceId,
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close({ cirfClient: this.cirfClientNew });
  }
}
